exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".header-title {\n    margin-top: 0;\n}\n\n.option-left {\n    padding-left: 16px;\n    margin-top: 12px;\n}\n\n.option-right {\n    padding-right: 16px;\n    margin-top: 18px;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/project/project.component.css
// module id = 821
// module chunks = 0